module.exports = __webpack_public_path__ + "static/media/cf.5a79f4f1.svg";